/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Team_Support_LabelInputs */



/**
* | output |
* | --- |
* | "Automatic preparation of my 1:1s with {name}" |
*
* @param {Team_Support_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_support_label = /** @type {((inputs: Team_Support_LabelInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Support_LabelInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Automatische voorbereiding van mijn 1:1's met ${i?.name}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Préparation automatique de mes one-to-ones avec ${i?.name}`)
	return /** @type {LocalizedString} */ (`Automatic preparation of my 1:1s with ${i?.name}`)
});